import { useState } from "react";
import { createProject } from "../../api/projectApi";

export default function useCreateProject() {
  const [loading, setLoading] = useState(false);

  const addProject = async (data) => {
    try {
      setLoading(true);

      const response = await createProject(data);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(error);

      return {
        success: false,
        error:
          error.response?.data ||
          error.message ||
          "Failed to create project",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    addProject,
    loading,
  };
}